
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import { Prop } from "vue-property-decorator"
import Bestellung from "@/entities/common/bestellung"
import { AbholungStatus } from "@/entities/common/enums"

@Component
export default class BestellungRowAbholung extends mixins(Calculator) {
  @Prop() bestellung: Bestellung

  formatiereAbholungStatus(bestellung: Bestellung): string {
    switch (bestellung.abholung.status) {
      case AbholungStatus.ABGEHOLT:
        return "abgeholt"
      case AbholungStatus.ABGELEHNT:
        return "abgelehnt"
      case AbholungStatus.ABGESENDET:
        return "noch nicht angenommen"
      case AbholungStatus.ABHOLBEREIT:
        return "abholbereit"
      case AbholungStatus.ANGENOMMEN:
        return "angenommen"
      case AbholungStatus.NICHT_ABGEHOLT:
        return "nicht abgeholt"
    }
  }
}
